import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class ClientCarousel extends Component {
  render() {
    const settings = {
      dots: false,
      autoplay: true,
      accessibility: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 6,
      arrows: false,
      slidesToScroll: 3,
      className: "message"
    };
    return (
      <div className="hero is-light">
        <div className="hero-body">
          <div className="container">
            <p className="title is-4">Who Uses Accratronics?</p>
            <Slider {...settings}>
              {clients.map(client => (
                <img src={client.logo} key={client.logo} alt="" />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}

const clients = [
  { logo: require("images/clientlogos/logo-spacex.png") },
  { logo: require("images/clientlogos/logo-pacsci.png") },
  { logo: require("images/clientlogos/logo-lockheed.png") },
  { logo: require("images/clientlogos/logo-navy.png") },
  { logo: require("images/clientlogos/logo-raytheon.png") },
  { logo: require("images/clientlogos/logo-parker.png") },
  { logo: require("images/clientlogos/logo-gd.png") },
  { logo: require("images/clientlogos/logo-roketsan.png") },
  { logo: require("images/clientlogos/logo-mod.png") }
];

export default ClientCarousel;



// WEBPACK FOOTER //
// ./src/pages/Home/components/ClientCarousel.js